import type { PropsWithChildren } from 'react';
import { type TAuthConfig, AuthProvider as Auth } from '@unbooking/ui-auth';
import axios from 'axios';

const axiosInstance = axios.create();
const scope = `email openid profile`;

const authConfig: TAuthConfig = {
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID || '',
  authorizationEndpoint: process.env.REACT_APP_AUTH_AUTHORIZATION_ENDPOINT || '',
  tokenEndpoint: process.env.REACT_APP_AUTH_TOKEN_ENDPOINT || '',
  refreshTokenEndpoint: process.env.REACT_APP_AUTH_REFRESHTOKEN_ENDPOINT || '',
  redirectUri: maybeAddHost(process.env.REACT_APP_AUTH_REDIRECT_URI || ''),
  logoutEndpoint: process.env.REACT_APP_AUTH_LOGOUT_ENDPOINT || '',
  logoutUri: maybeAddHost(process.env.REACT_APP_AUTH_LOGOUT_URI || ''),
  unbhApiUrl: (process.env.REACT_APP_HBH_API_URL || '').replace('/v2', ''),
  unbhApiKey: process.env.REACT_APP_UNBH_API_KEY || '',
  scope,
  configurations: {
    b2c: {
      authorizationEndpoint: process.env.REACT_APP_B2C_AUTHORIZATION_ENDPOINT || '',
      tokenEndpoint: process.env.REACT_APP_B2C_TOKEN_ENDPOINT ?? '',
      clientId: process.env.REACT_APP_B2C_CLIENT_ID || '',
      logoutEndpoint: process.env.REACT_APP_B2C_LOGOUT_ENDPOINT ?? '',
      logoutUri: maybeAddHost(process.env.REACT_APP_B2C_LOGOUT_URI || ''),
      scope: `${scope} offline_access`,
    },
    google: {
      authorizationEndpoint: process.env.REACT_APP_GOOGLE_AUTHORIZATION_ENDPOINT ?? '',
      tokenEndpoint: process.env.REACT_APP_GOOGLE_TOKEN_ENDPOINT ?? '',
      clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID ?? '',
      clientSecret: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_SECRET ?? '',
      scope,
    },
  },
};

const AuthProvider = ({ children }: PropsWithChildren) => {
  return (
    <Auth authConfig={authConfig} axiosInstance={axiosInstance}>
      {children}
    </Auth>
  );
};

export default AuthProvider;

function maybeAddHost(str = '') {
  return /^http/.test(str) ? str : `${window.location.origin}/${str}`.replace(/(?<!:)\/\//g, '/');
}
